import * as React from "react";
const SvgFiRrCircleZ = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-circle-z_svg__a)">
      <path
        fill="#062147"
        d="M12.038.02c-6.617 0-12 5.382-12 12s5.383 12 12 12 12-5.383 12-12-5.383-12-12-12m0 22c-5.514 0-10-4.486-10-10s4.486-10 10-10 10 4.486 10 10-4.486 10-10 10M9.06 15.807q.071.212.276.213h6.702a1 1 0 1 1 0 2H9.335c-1 0-1.854-.62-2.174-1.58a2.31 2.31 0 0 1 .808-2.616l6.937-5.208c.166-.125.142-.293.111-.382q-.071-.213-.276-.214H8.038a1 1 0 1 1 0-2h6.703c1 0 1.854.62 2.174 1.58a2.31 2.31 0 0 1-.808 2.614l-6.937 5.21c-.167.125-.142.293-.11.383"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-circle-z_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrCircleZ;
